import React from 'react';
import styled from 'styled-components';
interface FormItemProps {
  label?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}
const FormItemContainer: React.FC<FormItemProps> = ({
  className,
  style,
  label,
  htmlFor,
  required = false,
  error,
  children,
}) => {
  return (
    <FormItemWrapper className={className} style={style}>
      {label && (
        <Label htmlFor={htmlFor} required={required}>
          {label}
        </Label>
      )}
      {children}
      {error && <TextError>{error}</TextError>}
    </FormItemWrapper>
  );
};

export default FormItemContainer;
const FormItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Label = styled.label<{ required?: boolean }>`
  font-size: 14px;
  margin-bottom: 6px;
  ${({ required }) =>
    required &&
    `
      &::after {
        content: ' *';
        color: var(--color-10);
      }
    `}
`;
const TextError = styled.span`
  color: var(--color-10);
  margin-top: 4px;
  font-size: 11px;
`;
